import {useNavigate, useParams} from "react-router-dom";
import {useFetchTagCard} from "../../api/signcard";
import {useEffect} from "react";
import Swal from "sweetalert2";
import {LoginReason} from "../login/social-login";

const CardTagStatus = {
    INVALID: "INVALID",
    UNREGISTERED: "UNREGISTERED",
    CARD_DEACTIVATED: "CARD_DEACTIVATED",
    PROFILE_DRAFTED: "PROFILE_DRAFTED",
    OK: "OK"
}

function TagCardPage() {
    const navigate = useNavigate();
    const {cardUuid} = useParams();
    const [, fetchTagCard] = useFetchTagCard(cardUuid)

    const showCardRegisterAlert = () =>
        Swal.fire({
            title: '등록되지 않은 카드입니다. \n카드 등록을 위해 로그인 하시겠습니까?',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#2D2D2D',
            cancelButtonColor: '#2D2D2D',
            confirmButtonText: '확인',
            cancelButtonText: '취소'
        })

    const showCardDeactivateAlert = () =>
        Swal.fire({
            title: '사용할 수 없는 카드입니다.',
            text: '관리자에게 문의해주세요.',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            confirmButtonText: '확인',
            confirmButtonColor: '#2D2D2D'
        })


    useEffect(() => {
        if (fetchTagCard == null) return

        const cardTagStatus = fetchTagCard.status

        if (cardTagStatus === CardTagStatus.UNREGISTERED) {
            showCardRegisterAlert().then((result) => {
                if (result.isConfirmed) {
                    navigate("/login", {
                        state: {
                            reason: LoginReason.CARD_REGISTER,
                            cardUuid: cardUuid
                        }
                    })
                } else {
                    navigate("/")
                }
            })
        } else if (cardTagStatus === CardTagStatus.PROFILE_DRAFTED) {
            showCardRegisterAlert().then((result) => {
                if (result.isConfirmed) {
                    navigate("/login", {
                        state: {
                            reason: LoginReason.PROFILE_DRAFTED,
                            profileLink: fetchTagCard.profileLink
                        }
                    })
                } else {
                    navigate("/")
                }
            })
        } else if (cardTagStatus === CardTagStatus.CARD_DEACTIVATED) {
            showCardDeactivateAlert().then((_) => navigate("/not-found"))
        } else if (cardTagStatus === CardTagStatus.OK) {
            navigate(`/${fetchTagCard.profileLink}`);
        } else if (cardTagStatus === CardTagStatus.INVALID){
            navigate(`/`)
        }
    }, [navigate, fetchTagCard])
}

export default TagCardPage;
